import { useDidMount, useWillUnmount } from 'utils/hooks';

export const useCognitoWindowedSignInFormLifecycle = ({ handlers }) => {
  useDidMount(handlers.handleMount);
  useWillUnmount(handlers.handleUnmount);
};
